import * as React from 'react';
import PropTypes from 'prop-types';

export const Beneficiary = ({ width, height, ...props }) => (
  <svg
    data-icon='beneficiary'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M5 21c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h4.2c.233-.6.6-1.083 1.1-1.45.5-.367 1.067-.55 1.7-.55s1.2.183 1.7.55c.5.367.867.85 1.1 1.45H19c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v14c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 21H5Zm7-16.75a.728.728 0 0 0 .75-.75.728.728 0 0 0-.75-.75.728.728 0 0 0-.75.75.728.728 0 0 0 .75.75Zm-7 13.6a10.08 10.08 0 0 1 3.137-2.088C9.33 15.255 10.617 15 12 15s2.67.254 3.863.762A10.08 10.08 0 0 1 19 17.85V5H5v12.85ZM12 13c.967 0 1.792-.342 2.475-1.025A3.372 3.372 0 0 0 15.5 9.5c0-.967-.342-1.792-1.025-2.475A3.372 3.372 0 0 0 12 6c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 8.5 9.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 12 13Zm-5 6h10v-.25a7.313 7.313 0 0 0-2.325-1.313A8.183 8.183 0 0 0 12 17c-.933 0-1.825.146-2.675.438-.85.291-1.625.729-2.325 1.312V19Zm5-8c-.417 0-.77-.146-1.063-.438A1.446 1.446 0 0 1 10.5 9.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 12 8c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.438 1.063A1.446 1.446 0 0 1 12 11Z'
    />
  </svg>
);

Beneficiary.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Beneficiary.defaultProps = {
  width: 24,
  height: 24,
};
